import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button } from 'react-bootstrap';
import { FaTimes, FaTrash, FaEdit, FaCheck } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { useGetUsersQuery, useDeleteUserMutation } from '../../slices/usersApiSlice';

const UserListScreen = () => {
  const { data: users, refetch, isLoading, error } = useGetUsersQuery();
  
  const [deleteUser, { isLoading: loadingDelete} ] = useDeleteUserMutation();

  const deleteHandler = async (id) => {
    if (window.confirm("確定要刪除這位會員嗎？")) {
      try {
        await deleteUser(id);
        toast.success("會員已刪除");
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);;
      }
    };
  };

  return <>
  <h1>會員管理</h1>
    {isLoading ? <Loader /> : error ? <Message variant="danger">{error}</Message> : (
      <Table striped hover responsive className="table-sm">
        <thead>
          <tr>
            <th>會員編號</th>
            <th>姓名</th>
            <th>電子郵件</th>
            <th>管理員</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          { users.map((user) => (
            <tr key={user._id}>
              <td>{user._id}</td>
              <td>{user.name}</td>
              <td><a href={`mailto:${user.email}`}>{ user.email }</a></td>
              <td>
                { user.isAdmin ? (
                  <FaCheck style={{ color: "green" }} />
                ) : (
                  <FaTimes style={{ color: "red" }} />
                ) }
              </td>
              <td>
                <LinkContainer to={`/admin/user/${user._id}/edit`}>
                  <Button variant="success" className="btn-sm me-2" aria-label="編輯會員" title="編輯會員">
                    <FaEdit />
                  </Button>
                </LinkContainer>
                <Button
                  variant="danger"
                  className="btn-sm"
                  aria-label="刪除會員"
                  title="刪除會員"
                  onClick={() => deleteHandler(user._id)}
                >
                  <FaTrash style={{ color: "white"}} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </>

};

export default UserListScreen;